"use client";

/**
 * Org/brand logo image that strips empty SVG viewBox padding so logos
 * center correctly under object-contain.
 */

import { useTrimmedSvgLogoUrl } from "@/lib/use-trimmed-svg-logo-url";
import type { ReactElement } from "react";

export function BrandLogoImg({
  src,
  alt,
  title,
  className,
}: {
  readonly src: string;
  readonly alt: string;
  readonly title?: string;
  readonly className?: string;
}): ReactElement {
  const resolvedSrc: string = useTrimmedSvgLogoUrl(src) ?? src;
  return (
    // eslint-disable-next-line @next/next/no-img-element -- org logo from S3 proxy
    <img src={resolvedSrc} alt={alt} title={title} className={className} />
  );
}
